import { useEffect, useState } from 'react';

import axios from 'axios';

export type DeploymentInfo = {
    version: string;
    commit: string;
    environment: string;
    'deploy-date': string;
};

const getDeploymentInfo = async (): Promise<DeploymentInfo | null> => {
    try {
        const { protocol, hostname } = window.location;
        const deploymentJsonUrl = `${protocol}//${hostname}/deployment-info.json`;
        const deploymentJson = await axios.get<DeploymentInfo>(deploymentJsonUrl);
        const deploymentInfo = deploymentJson.data;

        return deploymentInfo;
    } catch {
        return null;
    }
};

export const useDeploymentInfo = () => {
    const [deploymentInfo, setDeploymentInfo] = useState<DeploymentInfo | null>(null);

    useEffect(() => {
        getDeploymentInfo().then(setDeploymentInfo);
    }, []);

    return deploymentInfo;
};
